export enum APIStatus {
    ERROR = "ERROR",
    OK = "OK"
}